module.exports = __webpack_public_path__ + "static/jan_burzynski@x1-30af3e848242133644756a591af69d3f.jpg";